import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const TESTIMONIAL_IMAGES = ["https://cdn.magicpatterns.com/uploads/oeMxatiyhoVb6dszoMbRb6/ChatGPT_Image_29_jul_2026,_12_56_14.webp", "https://cdn.magicpatterns.com/uploads/rip3c25F2iUzJkfYdefRKa/ChatGPT_Image_29_jul_2026,_12_56_08_(1).webp", "https://cdn.magicpatterns.com/uploads/nDWVZWoC69X8Yur3wHtGot/ChatGPT_Image_29_jul_2026,_12_51_10.webp", "https://cdn.magicpatterns.com/uploads/otUaLinMsRcpePAwwdtQWa/ChatGPT_Image_29_jul_2026,_12_48_43.webp", "https://cdn.magicpatterns.com/uploads/d9jnQbgFPcAo5HoDM2tjZb/ChatGPT_Image_29_jul_2026,_12_48_40.webp"];
const duplicatedImages = [...TESTIMONIAL_IMAGES, ...TESTIMONIAL_IMAGES];
const rotations = ['-rotate-2', 'rotate-3', '-rotate-1', 'rotate-2', '-rotate-3'];
export function Testimonials() {
  return <section id="opiniones" className="w-full bg-gradient-to-b from-[#1C3587] to-[#0F2A55] py-20 sm:py-28 overflow-hidden pt-[25px]" data-id="element-525" data-mp="qalj3y2dn7ty">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-526" data-mp="h4wysdjfawnh">
        <Reveal className="text-center" data-id="element-527" data-mp="m4rncafq7a5d">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 font-display text-xs font-extrabold uppercase tracking-[0.14em] text-white backdrop-blur-sm" data-id="element-528" data-mp="m5sx8bl09qli">
            💬 Opiniones de familias
          </span>
          <h2 className="mt-6 font-black text-white sm:text-5xl text-[36px] font-[Barlow,_sans-serif]" data-id="element-529" data-mp="c8oigwthoxeq">
            Familias que ya
            <br data-id="element-530" data-mp="14vsi0m9tcjj4" />
            <span className="text-[#FF8C22]" data-id="element-531" data-mp="14u7o8yvbp4mb">empezaron a crear</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg font-medium text-white/80" data-id="element-532" data-mp="q7egqfs1p34o">
            Mirá algunas respuestas de mamás que ya recibieron Mini Constructores.
          </p>
        </Reveal>
      </div>

      <div className="relative mt-14 w-full py-10" data-id="element-533" data-mp="1iu8z975axsfi">
        {/* Gradient masks for smooth fade in/out at edges */}
        <div className="pointer-events-none absolute bottom-0 left-0 top-0 z-10 w-16 bg-gradient-to-r from-[#182F72] to-transparent sm:w-48" data-id="element-534" data-mp="1nnlbsiwpi8rw" />
        <div className="pointer-events-none absolute bottom-0 right-0 top-0 z-10 w-16 bg-gradient-to-l from-[#182F72] to-transparent sm:w-48" data-id="element-535" data-mp="1siwewlub029d" />

        <motion.div className="flex w-max gap-6 sm:gap-10 px-4 sm:px-8" animate={{
        x: ['0%', '-50%']
      }} transition={{
        duration: 40,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-536" data-mp="1ofzsek1n7m05">
          {duplicatedImages.map((src, i) => <figure key={i} className={`relative w-[280px] flex-none overflow-hidden rounded-[2rem] border-[6px] border-white bg-white shadow-[0_10px_40px_rgba(0,0,0,0.12)] sm:w-[340px] transition-transform hover:scale-105 ${rotations[i % rotations.length]}`} data-id="element-537" data-mp="1el7rp7crkj15" data-mpi={i}>
              <img src={src} alt={`Testimonio ${i + 1}`} className="h-auto w-full object-cover" loading="lazy" data-id="element-538" data-mp="10t1e9t0zwq5e" />
            </figure>)}
        </motion.div>
      </div>

      <div className="mx-auto w-full max-w-4xl px-5 sm:px-8" data-id="element-539" data-mp="qtu41epk5bmi">
        <Reveal className="mt-10" data-id="element-540" data-mp="qvnb2v431xv1">
          <div className="p-4 sm:p-10" data-id="element-541" data-mp="32h5va6740pjp">
            <div className="grid grid-cols-2 gap-2 sm:gap-4" data-id="element-542" data-mp="32ge1n0x2p1w2">
              {/* Card 1 */}
              <div className="flex flex-col items-center justify-center rounded-2xl bg-white p-3 text-center shadow-sm sm:p-6" data-id="element-543" data-mp="37epb3ajghadr">
                <div className="flex items-center gap-0.5 sm:gap-1" data-id="element-544" data-mp="3ccz71nd08f0f">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-[#FF8C22] text-[#FF8C22] sm:h-4 sm:w-4" data-id="element-545" data-mp="3gekqxsnyhtk4" data-mpi={i} />)}
                </div>
                <p className="mt-2 font-display text-[11px] font-black leading-snug text-[#1C3587] sm:mt-4 sm:text-[15px]" data-id="element-546" data-mp="2opirllau8eqw">
                  “Pasamos toda la tarde armando el robot.”
                </p>
                <p className="mt-1 text-[9px] font-bold text-[#3B5BDB] sm:mt-2 sm:text-[12px]" data-id="element-547" data-mp="2xhko58hsdavw">
                  — Laura, mamá de Mateo
                </p>
              </div>

              {/* Card 2 */}
              <div className="flex flex-col items-center justify-center rounded-2xl bg-white p-3 text-center shadow-sm sm:p-6" data-id="element-548" data-mp="25105xdp1jjgy">
                <div className="flex items-center gap-0.5 sm:gap-1" data-id="element-549" data-mp="1lxoltds2v2ch">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-[#FF8C22] text-[#FF8C22] sm:h-4 sm:w-4" data-id="element-550" data-mp="1gz4xj6q0hegy" data-mpi={i} />)}
                </div>
                <p className="mt-2 font-display text-[11px] font-black leading-snug text-[#1C3587] sm:mt-4 sm:text-[15px]" data-id="element-551" data-mp="1vo14f0gc0lfz">
                  “Los videos son súper claros para los chicos.”
                </p>
                <p className="mt-1 text-[9px] font-bold text-[#3B5BDB] sm:mt-2 sm:text-[12px]" data-id="element-552" data-mp="24phdn4veuhim">
                  — Martín, papá de Lucas
                </p>
              </div>

              {/* Card 3 */}
              <div className="flex flex-col items-center justify-center rounded-2xl bg-white p-3 text-center shadow-sm sm:p-6" data-id="element-553" data-mp="2ej7z00w8qbu3">
                <div className="flex items-center gap-0.5 sm:gap-1" data-id="element-554" data-mp="k71do99mueo2">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-[#FF8C22] text-[#FF8C22] sm:h-4 sm:w-4" data-id="element-555" data-mp="f8zt1jwk67ah" data-mpi={i} />)}
                </div>
                <p className="mt-2 font-display text-[11px] font-black leading-snug text-[#1C3587] sm:mt-4 sm:text-[15px]" data-id="element-556" data-mp="2qx4ob4lopwm4">
                  “Me encantó que usamos puras cosas recicladas.”
                </p>
                <p className="mt-1 text-[9px] font-bold text-[#3B5BDB] sm:mt-2 sm:text-[12px]" data-id="element-557" data-mp="2h5h2pkbt79sk">
                  — Ana, mamá de Juli
                </p>
              </div>

              {/* Card 4 */}
              <div className="flex flex-col items-center justify-center rounded-2xl bg-white p-3 text-center shadow-sm sm:p-6" data-id="element-558" data-mp="283r2pq3v32j6">
                <div className="flex items-center gap-0.5 sm:gap-1" data-id="element-559" data-mp="2c4kqmjhb0hc2">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-3 w-3 fill-[#FF8C22] text-[#FF8C22] sm:h-4 sm:w-4" data-id="element-560" data-mp="1y9h96536ny6v" data-mpi={i} />)}
                </div>
                <p className="mt-2 font-display text-[11px] font-black leading-snug text-[#1C3587] sm:mt-4 sm:text-[15px]" data-id="element-561" data-mp="3sknmev3zguby">
                  “Por fin una actividad que los aleja de la tele.”
                </p>
                <p className="mt-1 text-[9px] font-bold text-[#3B5BDB] sm:mt-2 sm:text-[12px]" data-id="element-562" data-mp="3w3cxvik3dldt">
                  — Carolina, mamá de Pedro
                </p>
              </div>
            </div>

            {/* Bottom Highlight Card */}
            <div className="mt-3 flex items-center gap-3 rounded-2xl border-2 border-[#FF8C22] bg-[#FFF5ED] p-3 shadow-sm sm:mt-4 sm:gap-4 sm:p-5" data-id="element-563" data-mp="3m55j96d9zfez">
              <div className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-[#FF8C22] text-lg text-white shadow-sm sm:h-12 sm:w-12 sm:text-xl" data-id="element-564" data-mp="ioq153j3a4sw">
                ✨
              </div>
              <p className="font-display text-[11px] font-black leading-snug text-[#1C3587] sm:text-[16px]" data-id="element-565" data-mp="8xlowbkssy1r">
                Una forma simple de transformar el tiempo en casa en juego, creatividad y aprendizaje.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}